exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-row[data-v-07fc36ae] {\n  margin-bottom: 0.5rem !important;\n}\n", ""]);

// exports
